export default {"icons":{"iconfont":"mdi"}}
